<template>
  <div>
    <div class="addPerson__wrap" v-show="visible">
      <el-header class="shadow page-header__wrap">
        <div class="flex">
          <div class="backBtn" @click="handleReturn">
            <el-image
              class="back-img"
              :src="require('@/assets/img/back.png')"
            ></el-image>
            <span>返回</span>
          </div>
          <div class="title">
            <span class="site">当前位置：</span>
            {{ $route.meta.title }}
            <span> > </span>
            查看详情({{ currentRow.name }})
          </div>
        </div>
      </el-header>
      <div class="main">
        <div class="mainBox">
          <el-form
            style="margin-bottom: 10px"
            ref="elFormDom"
            inline
            :model="table.params"
            :size="subUnitSize"
          >
            <el-form-item label="商品名称" prop="goods_name">
              <el-input
                size="mini"
                v-model.trim="table.params.goods_name"
                placeholder="请输入"
                clearable
                @keydown.enter.native="onSearch"
              ></el-input>
            </el-form-item>
            <el-form-item label="下单分类" prop="order_cate_id">
              <el-cascader
                v-model="table.params.order_cate_id"
                filterable
                placeholder="请选择"
                id="order_cate_id"
                :options="orderCateArr"
                :props="{
                  children: 'child',
                  label: 'name',
                  value: 'id',
                  checkStrictly: true,
                }"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="onSearch"
                >搜索</el-button
              >
              <el-button icon="el-icon-refresh-right" @click="reset"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
          <el-row style="margin-bottom: 10px">
            <el-button plain :size="subUnitSize" @click="addGoods"
              >添加商品</el-button
            >
            <el-button
              type="primary"
              plain
              :size="subUnitSize"
              v-if="is_sys"
              @click="batchDeleteGoods"
              >批量删除</el-button
            >
          </el-row>
          <el-table
            :data="table.data"
            style="width: 100%"
            :row-key="(row) => row.id"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="60">
            </el-table-column>
            <el-table-column
              property="goods_name"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              property="order_cate_name"
              label="商品类别"
            ></el-table-column>
            <el-table-column
              property="unit_name"
              label="单位"
            ></el-table-column>
            <el-table-column
              property="spec_name"
              label="规格"
            ></el-table-column>
            <el-table-column property="amount" label="锁定单价/元">
              <template slot-scope="{ row }">
                <span :class="{ greenColor: row.is_low }">{{
                  row.amount
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column
              property="create_name"
              label="创建人"
            ></el-table-column>
            <el-table-column
              width="120"
              fixed="right"
              property="action"
              label="操作"
            >
              <template slot-scope="{ row }">
                <el-button type="text" class="editBtn" @click="editRow(row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  v-if="is_sys"
                  class="delBtn"
                  @click="deleteRow(row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex" justify="end" style="padding-right: 50px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="table.params.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="table.params.count"
              layout="total, sizes, prev, pager, next, jumper"
              :total="table.total"
            >
            </el-pagination>
          </el-row>
        </div>
      </div>
    </div>
    <addLockDetail ref="addLockDetailRef" @confirm="getTable"></addLockDetail>
  </div>
</template>
<script>
import { mixinTable } from "@/mixins/table.js";
import addLockDetail from "./addLockDetail.vue";
import { decorate_ } from "@/util/promise.js";
export default {
  components: { addLockDetail },
  mixins: [mixinTable],
  data() {
    return {
      currentRow: {},
      subUnitSize: this.$store.state.subUnitSize,
      visible: false,
      orderCateArr: [], //商品分类
      table: {
        params: {
          page: 1,
          count: 10,
          goods_name: "",
          order_cate_id: [],
        },
        total: 0,
        data: [],
      },
      selectedRows: [],
    };
  },
  methods: {
    toggle(show) {
      this.visible = show;
      !show && this.resetDetail();
    },
    resetDetail() {
      this.currentRow = {};
      this.table.params = {
        page: 1,
        count: 10,
        goods_name: "",
        order_cate_id: [],
      };
    },
    getDetail(row,goods_name) {
      this.table.params.goods_name = goods_name;
      this.currentRow = row;
      this.getOrderCateSel(); // 下单分类
      this.getTable();
    },
    handleReturn() {
      this.$emit("refresh");
      this.toggle(false);
      this.table.data = [];
    },
    async getTable() {
      console.log(this.table.params, "this.table.params");
      let { order_cate_id = [] } = this.table.params;

      let params = {
        ...this.table.params,
        supplier_id: this.currentRow.id,
        order_cate_id: order_cate_id.length ? order_cate_id[0] : "",
        order_cate_tow: order_cate_id.length == 2 ? order_cate_id[1] : "",
      };
      this.table.loading = true;
      // const res = await this.$http.get("/admin/lock/info", { params: params });
      const [err, res] = await decorate_(this.$http.get("/admin/lock/info", { params: params }));
      this.table.loading = false;
      if (res.code == 1) {
        this.table.data = res.data.list;
        this.table.total = res.data.total;
      }
    },
    addGoods() {
      let dom = this.$refs.addLockDetailRef;
      dom.toggle(true);
      dom.getDetail(this.currentRow);
    },
    editRow(row) {
      let dom = this.$refs.addLockDetailRef;
      dom.toggle(true);
      let row_ = {
        ...this.currentRow,
        supplier_id: this.currentRow.id,
        ...row,
      };
      dom.getDetail(row_);
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    deleteRow(row) {
      this.$confirm(`请确认删除操作`, `提示`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$http
          .post("/admin/lock/deleteGoods", {
            ids: row.id,
            supplier_id: this.currentRow.id,
          })
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: `删除成功`,
              });
              this.getTable();
            }
          });
      });
    },
    batchDeleteGoods() {
      if (this.selectedRows.length) {
        this.$confirm(
          `已选商品:${this.selectedRows.length}项,确认删除吗`,
          `批量删除`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        ).then(() => {
          this.$http
            .post("/admin/lock/deleteGoods", {
              ids: this.selectedRows.map((i) => i.id).join(","),
              supplier_id: this.currentRow.id,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message({
                  type: "success",
                  message: `删除成功`,
                });
                this.getTable();
              }
            });
        });
      } else {
        this.$message.warning("请选择要删除的商品");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}
.addPerson__wrap .main {
  overflow-x: hidden;
  background: #fff;
}
.returnBtn {
  z-index: 99;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
}
.footerWrap {
  text-align: center;
  padding: 10px;
  box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%),
    0 2px 4px 0 rgb(232 237 250 / 50%);
  z-index: 99;
}
.itemTime {
  display: block;
  margin-bottom: 10px;
  height: 30px;
  line-height: 30px;
}
.itemTime::before {
  content: "";
  width: 5px;
  height: 15px;
  background: #2cb167;
  border-radius: 6px;
  display: inline-block;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.flex {
  display: flex;
}
.mt20 {
  margin-top: 20px;
}
.mb20 {
  margin-bottom: 20px;
}
.width200px {
  width: 200px;
}
.after-table {
  padding: 10px;
  font-size: 13px;
  color: #303030;
  text-align: right;
}
.pageWrap {
  margin-top: 10px;
  text-align: right;
  margin-right: 36px;
}
</style>
